import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ShieldCheck, AlertTriangle, Loader2, Download } from "lucide-react";
import ChangePasswordCard from "@/components/ChangePasswordCard";

export default function AdminCompliance() {
  const [c, setC] = useState(null);
  useEffect(() => { api.get("/admin/compliance").then((r) => setC(r.data)).catch(() => {}); }, []);
  if (!c) return <div className="p-8 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#3A2DB8]" /></div>;

  const exportJson = () => {
    const url = URL.createObjectURL(new Blob([JSON.stringify(c, null, 2)], { type: "application/json" }));
    const a = document.createElement("a"); a.href = url; a.download = `trinity-soc2-evidence-${c.generated_at.slice(0, 10)}.json`; a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-4" data-testid="admin-compliance">
      <div className="lg:col-span-2 space-y-4">
        <div className="card-soft p-6">
          <div className="flex flex-wrap items-center gap-3">
            <ShieldCheck className="w-6 h-6 text-[#0F9D77]" />
            <div className="flex-1 min-w-0">
              <h3 className="font-heading font-bold text-xl text-[#1E1560]">SOC 2 control self-assessment</h3>
              <p className="text-xs text-secondary">{c.framework}</p>
            </div>
            <div className="text-right">
              <div className="font-heading font-bold text-3xl" style={{ color: c.score >= 90 ? "#0F9D77" : "#FF8A3D" }} data-testid="compliance-score">{c.score}%</div>
              <div className="text-[11px] text-secondary">{c.passed}/{c.total} controls</div>
            </div>
            <Button variant="outline" onClick={exportJson} className="rounded-full border-border gap-1" data-testid="compliance-export-btn"><Download className="w-4 h-4" /> Evidence JSON</Button>
          </div>
        </div>
        <div className="card-soft divide-y divide-border">
          {c.controls.map((x, i) => (
            <div key={`${x.criteria}-${i}`} className="p-4 flex items-start gap-3" data-testid={`control-${i}`}>
              {x.status === "pass" ? <ShieldCheck className="w-5 h-5 text-[#0F9D77] shrink-0 mt-0.5" /> : <AlertTriangle className="w-5 h-5 text-[#FF8A3D] shrink-0 mt-0.5" />}
              <div className="min-w-0 flex-1">
                <div className="text-sm font-medium text-[#1E1560]">{x.control}</div>
                <div className="text-xs text-secondary mt-0.5">{x.evidence}</div>
              </div>
              <Badge className="rounded-full text-[10px] bg-muted text-secondary shrink-0">{x.criteria}</Badge>
              <Badge className={`rounded-full text-[10px] shrink-0 ${x.status === "pass" ? "bg-[#0F9D77]/15 text-[#0F9D77]" : "bg-[#FF8A3D]/15 text-[#B45309]"}`}>{x.status === "pass" ? "Pass" : "Action required"}</Badge>
            </div>
          ))}
        </div>
        <div className="card-soft p-5">
          <p className="text-xs font-semibold text-[#1E1560] mb-2">Manual / organisational controls (outside the platform)</p>
          <ul className="list-disc list-inside text-xs text-secondary space-y-1">{c.manual_controls.map((m) => <li key={m}>{m}</li>)}</ul>
        </div>
      </div>
      <ChangePasswordCard />
    </div>
  );
}
